// axios-config.js
import Axios from "axios";
import store from "../store";
import router from "../router";

// Helper to access global i18n t()
function translate(key) {
  return window?.app?.config?.globalProperties?.$t?.(key) || key;
}

// Create Axios instance
const axios = Axios.create({
  // baseURL: "http://localhost:3001/vms-api", // Proxy in dev mode
  withCredentials: true,
  timeout: 18000, // 30 minutes
});

// Request Interceptor
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("loginToken");
  const appId = 1;

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  config.headers["vms-app-id"] = appId;

  store.dispatch("setLoading", { loading: true });
  return config;
});

// Response Interceptor
axios.interceptors.response.use(
  (response) => {
    store.dispatch("setLoading", { loading: false });

    // If backend sends updated token in Authorization header
    const authHeader = response.headers["authorization"];
    if (authHeader && authHeader.startsWith("Bearer ")) {
      const newToken = authHeader.split(" ")[1];
      store.dispatch("setLoginInfo", { token: newToken });
      localStorage.setItem("loginToken", newToken);
    }

    // Global message
    if (response.data?.code) {
      store.dispatch("setGlobalMessage", {
        message: {
          code: response.data.code,
          message: response.data.message,
        },
      });
    }

    return response;
  },
  (error) => {
    store.dispatch("setLoading", { loading: false });

    if (error.code === "ECONNABORTED") {
      store.dispatch("setGlobalMessage", {
        message: {
          code: null,
          message: translate("altMsgs.apiTimeoutError"),
        },
      });
      return { status: 500 };
    }

    if (!error.response) {
      store.dispatch("setGlobalMessage", {
        message: { code: null, message: translate("altMsgs.networkError") },
      });
      return { status: 500 };
    }

    const status = error.response.status;
    const errMessage = error.response.data?.message;

    if (status === 400 || status === 401 || status === 403 || status === 500) {
      store.dispatch("setGlobalMessage", {
        message: {
          code: error.response.data?.code ?? null,
          message: errMessage ?? translate("altMsgs.errorOccured"),
        },
      });

      if (status === 401 && !localStorage.getItem("loginSuccess")) {
        // Clear session and redirect to login
        localStorage.removeItem("loginToken");
        localStorage.removeItem("user_details");
        router.push({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath },
        });
      }
    } else if (status === 404) {
      store.dispatch("setGlobalMessage", {
        message: { code: null, message: translate("altMsgs.apiNotFound") },
      });
    }

    return error.response;
  }
);

export default axios;
